import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectChatStyles = makeStyles((theme) =>
  createStyles({
    titleContainer: {
      display: 'flex',
      marginBottom: theme.spacing(4),
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'row'
      }
    },

    button: {
      marginTop: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        marginTop: 0
      }
    }
  })
)
